module.exports = __webpack_public_path__ + "img/22.bad0d23b.jpg";